import * as R from "ramda";

export const isFetching = state => state.eventUsers.fetching;
export const users = state => state.eventUsers.users;
export const error = state => state.eventUsers.error;
export const user = state => R.pathOr({}, ["eventUsers", "user"], state);
